import {CanActivateFn} from "@angular/router";
import {AuthService} from "./auth.service";
import {inject} from "@angular/core";
import {map} from "rxjs/operators";

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);

  const user = auth.getLoggedInUser();

  if(!user) {
    auth.lastRoute = state.url;
    return auth.getUserDetails(state.url === '/' || state.url.startsWith('/dashboard')).pipe(map(() => true));
  } else
    return true;

}
